import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Attachment } from '@digital-platform/attachments/domain';
import { FileUploadService, UploadStatus } from '@digital-platform/shared/ui';
import { AttachmentUploadService } from '../attachment-upload/attachment-upload.service';

@Injectable({
  providedIn: 'root',
})
export class AttachmentUploadFacadeService extends FileUploadService<Attachment> {
  constructor(private service: AttachmentUploadService) {
    super();
  }

  public upload(file: File) {
    this.reduce({
      status: UploadStatus.Requested,
      error: null,
      progress: null,
      fileName: file.name,
    });

    this.service
      .create(file)
      .subscribe((event) => this.updateStateFromHttpEvent(event, file));
  }

  public remove(attachment: Attachment) {
    this.reduce({
      status: UploadStatus.Requested,
      error: null,
      progress: null,
      fileName: attachment.fileName,
    });

    this.service.del(attachment).subscribe((response) => {
      this.reduce({
        status: UploadStatus.Deleted,
        progress: 100,
        error: null,
        fileName: attachment.fileName,
        response,
      });
    });
  }

  private updateStateFromHttpEvent(event: HttpEvent<any>, file: File) {
    switch (event.type) {
      case HttpEventType.Sent: {
        this.reduce({
          status: UploadStatus.Started,
          error: null,
          progress: 0,
          response: null,
          fileName: file.name,
        });
        break;
      }
      case HttpEventType.UploadProgress: {
        this.reduce({
          progress: Math.round((100 * event.loaded) / (event.total || 1)),
          fileName: file.name,
        });
        break;
      }
      case HttpEventType.Response: {
        if (event.status === 200) {
          this.reduce({
            status: UploadStatus.Completed,
            progress: 100,
            error: null,
            fileName: file.name,
            response: {
              ...event.body,
              fileName: file.name, // TODO: this override may want to be removed in the future, e.g. if the server renames the uploaded file so we can display the renamed value
            },
          });
        } else {
          this.reduce({
            error: event.statusText,
            fileName: file.name,
          });
        }
        break;
      }
      default: {
        this.reduce({
          error: `Unknown Event: ${JSON.stringify(event)}`,
          fileName: file.name,
        });
      }
    }
  }
}
